import { IconSVG } from '../types';

export function Language({ size, style }: IconSVG) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      style={style}
      viewBox="0 0 16 16"
    >
      <g fill="currentColor" fillRule="evenodd" clipPath="url(#clip0_11834_283)" clipRule="evenodd">
        <path d="M.668 7.997a7.333 7.333 0 1 1 14.667 0 7.333 7.333 0 0 1-14.667 0m7.333-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12" />
        <path d="M.668 7.995c0-.368.298-.667.667-.667h13.333a.667.667 0 0 1 0 1.333H1.335a.667.667 0 0 1-.667-.666" />
        <path d="M8.001.664c.188 0 .366.079.493.217a10.87 10.87 0 0 1 2.84 7.13 10.87 10.87 0 0 1-2.84 7.103.667.667 0 0 1-.985 0 10.87 10.87 0 0 1-2.84-7.13A10.87 10.87 0 0 1 7.508.88a.67.67 0 0 1 .492-.217m0 1.7a9.53 9.53 0 0 0-2 5.633 9.53 9.53 0 0 0 2 5.633 9.53 9.53 0 0 0 2-5.633 9.53 9.53 0 0 0-2-5.632" />
      </g>
      <defs>
        <clipPath id="clip0_11834_283">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
